export default __webpack_public_path__ + "static/media/royal_greatsword.fbc5184a.png";